import { cn } from "@/lib/utils";

export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 whitespace-nowrap font-display text-[18px] sm:text-[22px] font-medium leading-none tracking-[-0.015em] text-foreground",
        className
      )}
    >
      <span aria-hidden className="inline-block size-[9px] rounded-full bg-star" />
      Tables
    </span>
  );
}
